import React, { useState } from "react";
import { ChevronDown, HelpCircle } from "lucide-react";
import { useJsonLd, faqSchema } from "../lib/seo";

export const faqs = [
  {
    q: "Εξυπηρετείτε στη Λαμία και γύρω περιοχές;",
    a: "Ναι! Εξυπηρετούμε όλη τη Φθιώτιδα με κατ' οίκον επισκευή: Λαμία, Στυλίδα, Αταλάντη, Δομοκός, Μακρακώμη, Καμένα Βούρλα, Άγιος Κωνσταντίνος και ολόκληρη την ευρύτερη περιοχή. Τηλεφωνήστε μας να δούμε την περίπτωσή σας.",
  },
  {
    q: "Πόσο κοστίζει η αλλαγή οθόνης σε iPhone ή Samsung στη Λαμία;",
    a: "Η τιμή εξαρτάται από το μοντέλο. Ξεκινάει από 25€ για οθόνες παλαιότερων μοντέλων. Για ακριβή διάγνωση και προσφορά, τηλεφωνήστε μας πείτε μας το μοντέλο της συσκευής σας.",
  },
  {
    q: "Έρχεστε στο σπίτι μου ή πρέπει να σας φέρω τη συσκευή;",
    a: "Έρχόμαστε εμείς στο χώρο σας. Κάνουμε κατ' οίκον επισκευή με πλήρη εξοπλισμό. Αν χρειαστεί η επισκευή να γίνει στο εργαστήριο, παραλαμβάνουμε και παραδίδουμε δωρεάν.",
  },
  {
    q: "Πόσο γρήγορα γίνεται μια επισκευή;",
    a: "Οι περισσότερες αλλαγές οθόνης ή μπαταρίας ολοκληρώνονται σε 30–60 λεπτά. Πιο πολύπλοκες επισκευές (μητρικά, ανάκτηση δεδομένων) μπορεί να χρειάζονται 1-3 ημέρες.",
  },
  {
    q: "Δίνετε εγγύηση στις επισκευές;",
    a: "Ναι! Δίνουμε 6 μήνες εγγύηση σε όλες τις επισκευές μας. Χρησιμοποιούμε γνήσια ή premium ανταλλακτικά.",
  },
  {
    q: "Επισκευάζετε PlayStation και Xbox;",
    a: "Ναι! Κάνουμε καθαρισμό και service σε PS4, PS5, Xbox One και Xbox Series. Αλλαγή θερμοαγώγιμης πάστας, επισκευή χειριστηρίων και άλλες βλάβες. Τιμές από 25€.",
  },
  {
    q: "Κάνετε ανάκτηση δεδομένων από κατεστραμμένους δίσκους;",
    a: "Ναι, ανακτούμε φωτογραφίες, έγγραφα και αρχεία από σκληρούς δίσκους (HDD/SSD), USB και κάρτες SD. Η πρώτη διάγνωση είναι δωρεάν.",
  },
  {
    q: "Γίνεται να σας τηλεφωνήσω αργά το βράδυ ή Σάββατοκύριακο;",
    a: "Ναι! Είμαστε διαθέσιμοι 24 ώρες, 7 μέρες. Τηλεφωνήστε στο 6982917870 ή 6948898658, ή γράψτε μας στο WhatsApp/Viber.",
  },
];

const FAQ = () => {
  const [open, setOpen] = useState(0);
  useJsonLd("faq-home", faqSchema(faqs));

  return (
    <section id="faq" className="py-24 relative">
      <div className="relative max-w-4xl mx-auto px-5 lg:px-8">
        <div className="text-center reveal">
          <div className="text-xs uppercase tracking-[0.3em] text-emerald-300/80">
            Συχνές ερωτήσεις
          </div>
          <h2 className="mt-2 text-3xl md:text-4xl lg:text-5xl font-extrabold text-white tracking-tight">
            Έχετε <span className="text-emerald-400">ερώτηση</span>;
          </h2>
          <p className="mt-4 text-emerald-50/70">
            Συχνές απορίες πελατών μας στη Λαμία και τη Φθιώτιδα.
          </p>
        </div>

        <div className="mt-10 space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className={`pcb-card overflow-hidden transition-colors ${
                open === i ? "border-emerald-500/60" : ""
              }`}
            >
              <button
                onClick={() => setOpen(open === i ? -1 : i)}
                className="w-full flex items-center justify-between gap-4 p-5 text-left"
              >
                <div className="flex items-center gap-3">
                  <HelpCircle className="w-5 h-5 text-emerald-400 shrink-0" />
                  <span className="text-white font-semibold">{faq.q}</span>
                </div>
                <ChevronDown
                  className={`w-5 h-5 text-emerald-300 shrink-0 transition-transform ${
                    open === i ? "rotate-180" : ""
                  }`}
                />
              </button>
              {open === i && (
                <div className="px-5 pb-5 pl-14 text-sm text-emerald-50/80 leading-relaxed">
                  {faq.a}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
